<template>
  <div>
    <div class="back" v-if="dialogVisible" @click="hideModal"></div>
    <div class="serviceView" v-if="dialogVisible">
      <div class="modalView_pop">
        <div class="modalView_pop_l">
          <div class="modalView_pop_l_view">
            <div class="modalView_pop_l_view_t">
              <div class="modalView_pop_l_view_t_1">
                <div class="modalView_pop_l_view_t_3_text">{{$t('accountI18n.title')}}</div>
              </div>
              <div class="modalView_pop_l_view_t_2">{{$t('accountI18n.desc')}}</div>
            </div>
            <div class="modalView_pop_l_view_b">
              <div class="dialog-user-info">
                <!-- 用户名编辑区域 -->
                <div class="user-header">
                  <el-input
                    v-model="userObject.user_name"
                    type="text"
                    v-if="showEditInput"
                    autofocus
                    class="user-name-input"
                    placeholder="请输入用户名"
                    @blur="handleUserNameChange"
                  />
                  <h3 class="user-name" v-else>
                    {{ userObject.user_name }}
                    <i class="el-icon-edit pointer" @click="editUserName"></i>
                  </h3>
                </div>

                <!-- 用户信息卡片 -->
                <div class="user-info-cards">
                  <!-- 用户ID -->
                  <!-- <div class="info-card">
                    <div class="card-label">{{$t('accountI18n.userID')}}</div>
                    <div class="card-value">{{ userObject.user_id }}</div>
                  </div> -->
                  
                  <!-- 手机号码 -->
                  <div class="info-card">
                    <div class="card-label">{{$t('accountI18n.phone')}}</div>
                    <div class="card-content">
                      <div class="card-value">{{ userObject.phone }}</div>
                      <i class="el-icon-edit pointer" @click="editUserInfo('手机')"></i>
                    </div>
                  </div>
                  
                  <!-- 邮箱 -->
                  <div class="info-card">
                    <div class="card-label">{{$t('accountI18n.email')}}</div>
                    <div class="card-content">
                      <div class="card-value">{{ userObject.email }}</div>
                      <i class="el-icon-edit pointer" @click="editUserInfo('邮箱')"></i>
                    </div>
                  </div>
                  
                  <!-- 所属公司 -->
                  <div class="info-card">
                    <div class="card-label">{{$t('accountI18n.company')}}</div>
                    <div class="card-content">
                      <div class="card-value">{{ userObject.company }}</div>
                      <el-input
                        v-model="company"
                        type="text"
                        v-if="showEditCompany"
                        autofocus
                        class="user-name-input"
                        placeholder="请输入公司名称"
                        @blur="handleCompanyChange"
                      />
                      <i class="el-icon-edit pointer" v-if="!userObject.company" @click="editCompanyName"></i>
                    </div>
                  </div>
                </div>
                
                <el-button type="text" style="float: right;font-size: 16px;" @click="editUserInfo('密码')">{{$t('accountI18n.change_password')}}</el-button>
                
                <!-- 平台协议 -->
                <div class="remark-section">
                  <p class="remark-content">
                    <span @click="navigateTo('privacy')">{{$t('accountI18n.privacy')}}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SafeValiate
      :visible.sync="safeValiate"
      :phone="userInfo?.phone"
      @close="safeValiate = false"
      @success="onSafeValidateSuccess"
    />
    <EPP
      :editValiate="editValiate"
      :editType="editType"
      :validationType="validationType"
      :validationValue = "validationValue"
      :phoneOrEmail="phoneOrEmail"
      @close="editValiate = false"
      @success="editSuccess"
    />
  </div>
</template>

<script>
import { getAccount, updateAccount } from "@/api/index";
import SafeValiate from "@/components/SafeValiate";
import EPP from "./EPP.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    SafeValiate,
    EPP
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userObject: {},
      showEditInput: false,
      showEditCompany: false,
      editType: "",
      validationType: "1",
      safeValiate: false,
      editValiate: false,
      validationValue: "",
      phoneOrEmail: "",
      company: "",
    };
  },
  methods: {
    hideModal() {
      this.$emit("update", false);
    },
    ...mapMutations(['setUserInfo']),

    async getUserInfo() {
      if (!this.userInfo?.user_name) {
        return;
      }
      try {
        const {
          data: { data: user },
        } = await getAccount({
          user_id: this.userInfo?.user_id,
        });
        this.userObject = user;
        this.setUserInfo(user);
      } catch (error) {
        this.$emit("update", false);
        this.$message.error(error || this.$t('accountI18n.getUserInfoError'));
      }
    },
    closeDialog() {
      this.$emit("update", false);
    },
    navigateTo(type) {
      const routes = {
        privacy: this.$router.resolve({ name: "Privacy" }).href,
      };
      const url = routes[type];
      if (url) {
        window.open(url, "_blank");
      }
    },
    editUserName() {
      this.showEditInput = true;
    },
    handleUserNameChange() {
      updateAccount({
        user_name: this.userObject.user_name,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(this.$t('accountI18n.userNameUpdateSuccess'));
          this.showEditInput = false;
          this.getUserInfo();
        }
      }).catch((error) => {
        this.$message.error(error || this.$t('accountI18n.userNameUpdateError'));
      });
    },
    editCompanyName() {
      this.showEditCompany = true;
    },
    // 处理公司名称更新
    handleCompanyChange() {
      updateAccount({
        company: this.company,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("更新成功");
          this.showEditCompany = false;
          this.getUserInfo();
        }
      }).catch((error) => {
        this.$message.success("更新失败");
      });
    },

    editUserInfo(type) {
      this.editType = type;
      this.$confirm(this.$t('accountI18n.editUserInfoConfirm') + this.$t('accountI18n.editUserInfoConfirmType.' + type), {
        type: "warning",
        customClass: 'my-message-box',
        confirmButtonText: this.$t('accountI18n.confirm'),
        cancelButtonText: this.$t('accountI18n.cancel'),
      })
        .then(() => {
          this.safeValiate = true;
        })
        .catch(() => {});
    },
    onSafeValidateSuccess(data, validationValue, phoneOrEmail) {
      this.safeValiate = false;
      this.editValiate = true;
      this.validationType = data;
      this.validationValue = validationValue;
      this.phoneOrEmail = phoneOrEmail
    },
    editSuccess() {
      this.editValiate = false;
      this.getUserInfo();
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.$watch("dialogVisible", (val) => {
      if (val) {
        this.getUserInfo();
      }
    });
  },
};
</script>

<style scoped lang="scss">
.back{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 999;
}
.serviceView {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
    background: var(--global-background);
    width: 600px;
    height: 750px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1001;

    .modalView_pop {
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        background-color: #ffffff;
        background-image: var(--global-inner-background);
        border-radius: 20px;
        display: flex;

        .modalView_pop_l {
            height: 100%;
            width: 91%;
            position: relative;

            .modalView_pop_l_view {
                width: 100%;
                height: 100%;
                margin: 0 10px 0 35px;
                border-left: 2px dashed #E3E6E8;
                border-right: 2px dashed #E3E6E8;

                .modalView_pop_l_view_t {
                    width: 100%;
                    border-bottom: 2px dashed #E3E6E8;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .modalView_pop_l_view_t_1 {
                        width: 100%;
                        height: 46px;
                        margin-left: 33px;

                        .modalView_pop_l_view_t_3_text{
                            font-size: 35px;
                            color: rgba(33, 33, 33, 1);
                            font-weight: 500;
                        }
                    }

                    .modalView_pop_l_view_t_2 {
                        font-size: 18px;
                        color: rgba(0, 0, 0, 1);
                        font-weight: 500;
                        margin-left: 35px;
                        letter-spacing: 3px;
                    }
                }

                .modalView_pop_l_view_b {
                    width: 100%;
                    height: calc(100% - 160px);
                    position: relative;
                    padding: 20px;

                    .dialog-user-info {
                        background-color: #fff;
                        border-radius: 10px;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                        padding: 20px;
                        display: flex;
                        flex-direction: column;
                        height: 100%;

                        .user-avatar-section {
                            display: flex;
                            justify-content: center;
                            margin-bottom: 20px;

                            .avatar-container {
                                width: 100px;
                                height: 100px;
                                border-radius: 50%;
                                background-color: #f0f0f0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                overflow: hidden;
                                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                                .user-avatar {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }
                        }

                        .user-header {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-bottom: 20px;
                            text-align: center;

                            .user-name-input {
                                flex: 1;
                                max-width: 300px;
                                margin: 0 10px;
                                border: 1px solid #ccc;
                                border-radius: 4px;
                                padding: 8px 12px;
                                font-size: 16px;
                                text-align: center;
                                transition: border-color 0.3s ease;

                                &:focus {
                                    outline: none;
                                    border-color: #7AE495;
                                }
                            }

                            .user-name {
                                flex: 1;
                                max-width: 300px;
                                margin: 0 10px;
                                font-size: 24px;
                                font-weight: bold;
                                color: #333;
                                position: relative;

                                .el-icon-edit {
                                    // position: absolute;
                                    // right: -20px;
                                    // top: 50%;
                                    // transform: translateY(-50%);
                                    cursor: pointer;
                                    color: #999;
                                    font-size: 18px;
                                    transition: color 0.3s ease;

                                    &:hover {
                                        color: #7AE495;
                                    }
                                }
                            }
                        }

                        .user-info-cards {
                            display: flex;
                            flex-direction: column;
                            gap: 12px;
                            margin-bottom: 20px;

                            .info-card {
                                background-color: #f9f9f9;
                                border-radius: 8px;
                                padding: 16px;
                                transition: transform 0.3s ease, box-shadow 0.3s ease;

                                &:hover {
                                    transform: translateY(-2px);
                                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
                                }

                                .card-label {
                                    font-size: 14px;
                                    color: #666;
                                    margin-bottom: 4px;
                                }

                                .card-value {
                                    font-size: 16px;
                                    color: #333;
                                }

                                .card-content {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                }

                                .el-icon-edit {
                                    cursor: pointer;
                                    color: #999;
                                    font-size: 16px;
                                    transition: color 0.3s ease;

                                    &:hover {
                                        color: #7AE495;
                                    }
                                }
                            }
                        }

                        .remark-section {
                            margin-top: auto;
                            text-align: center;

                            .remark-content {
                                font-size: 16px;

                                span {
                                    color: #606266;
                                    font-weight: bold;
                                    text-decoration: underline;
                                    cursor: pointer;
                                    transition: color 0.3s ease;

                                    // &:hover {
                                    //     color: #56C697;
                                    // }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
<style>
/* 确保该样式在全局或非 scoped 中 */
.my-message-box .el-message-box__content {
  font-size: 18px !important;
}

.my-message-box.el-message-box__header {
  font-size: 20px!important; 
}

.my-message-box .el-message-box__btns .el-button--small{
  font-size: 16px;
}
</style>